import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-96 z-50 flex items-center justify-center"
}
const _hoisted_2 = { class: "flex flex-col justify-center items-start w-full p-2 rounded-md bg-zewotherm-lightgrey drop-shadow-xl shadow-zewotherm-grey shadow-xl" }
const _hoisted_3 = { class: "flex flex-row w-full justify-between items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold text-xl" }, "Bild Name:", -1)

import { useCompany } from '@/store/company'
import { useSelectedProject } from '@/store/selectedProject'
import { camera, close } from 'ionicons/icons'
import { IonIcon, IonFab, IonFabButton } from '@ionic/vue'
import { Camera, CameraResultType, Photo } from '@capacitor/camera'
import { Ref, ref, watch } from 'vue'
import { loadingController } from '@ionic/core'
import axios from 'axios'
import { Storage } from '@capacitor/storage'



export default /*#__PURE__*/_defineComponent({
  __name: 'NewImage',
  emits: ["setPointerEvent"],
  setup(__props, { emit }: { emit: ({
  (e: 'setPointerEvent', v: boolean): void
}), expose: any, slots: any, attrs: any }) {

const selectedProjectStore = useSelectedProject()
const companyStore = useCompany()



const photoToSave: Ref<Photo | undefined> = ref()
const imgTitle = ref("")

watch(() => photoToSave.value, (value, oldValue) => {
  value ? emit("setPointerEvent", true) : emit("setPointerEvent", false)
})

async function saveFile() {
  const loading = await loadingController.create({
    message: 'Bitte warten...',
  });
  await loading.present();

  try {
    if(!photoToSave.value) return
    
    const realBase64String: string = 'data:image/' + photoToSave.value.format + ';base64,' + photoToSave.value.base64String
    const file: File = dataURLToFile(realBase64String, imgTitle.value, photoToSave.value.format)
    
    const response = await axios.get(process.env.VUE_APP_ZEWOTHERM_API_BASE_URL + 'jwt/project/upload-request/?project_id=' + selectedProjectStore.project._id + 
    '&company=' + companyStore.activeCompany.id +
    '&filename=' + file.name +
    '&filesize=' + file.size, {
      headers: {
        Authorization: 'Bearer ' + (await Storage.get({ key: 'jwt' })).value
      }
    })
    await axios.put(response.data.data.url, file)

    selectedProjectStore.documents.push({
      document_id: file.name,
      file_name: file.name,
      signed_url: realBase64String,
      valid_until: Infinity,
      name: file.name,
      path: realBase64String,
    })
    photoToSave.value = undefined
    imgTitle.value = ''
  } catch (e) {
    console.error(e)
  } finally {
    await loading.dismiss()
  }
}
async function takePhoto() {
  try {
    emit("setPointerEvent", true)
    const takenPhoto = await Camera.getPhoto({
      quality: 100,
      allowEditing: false,
      resultType: CameraResultType.Base64,
      promptLabelHeader: 'Foto',
      promptLabelPicture: 'Foto aufnehmen',
      promptLabelPhoto: 'Aus der Galerie',
      promptLabelCancel: 'Abbrechen',
    })
    photoToSave.value = takenPhoto
  } catch (e: any) {
    emit("setPointerEvent", false)
  }
  
}
function dataURLToFile(dataurl: string, filename: string, type: string): File {
  const arr: string[] = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)![1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n) {
    u8arr[n - 1] = bstr.charCodeAt(n - 1)
    n -= 1
  }
  return new File([u8arr], filename + '.' + type, {type:mime});   
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonFab), {
      vertical: "bottom",
      horizontal: "end",
      slot: "fixed"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonFabButton), {
          style: _normalizeStyle('--background:' + _unref(companyStore).activeCompany.color),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (takePhoto()))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonIcon), { icon: _unref(camera) }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }),
    (photoToSave.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(IonIcon), {
                icon: _unref(close),
                class: "w-5 h-5 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {photoToSave.value = undefined; imgTitle.value = ''})
              }, null, 8, ["icon"])
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((imgTitle).value = $event)),
              class: "w-full h-10 my-1 bg-white border placeholder-zewotherm-grey p-2 font-bold rounded-lg outline-none"
            }, null, 512), [
              [_vModelText, imgTitle.value]
            ]),
            _createElementVNode("button", {
              style: _normalizeStyle('background-color: ' + _unref(companyStore).activeCompany.color),
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (saveFile())),
              class: "w-full h-10 my-1 p-2 text-white font-bold rounded-lg text-center outline-none active:scale-95 duration-200"
            }, "Speichern", 4)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})